export default "__VITE_ASSET__DhzgCnvN__"